.page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.columns {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 18px;
  align-items: start;
}

/* On a phone the clinician's panel comes before the twenty answers. */
.side {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  order: -1;
}

@media (min-width: 720px) {
  .columns {
    grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr);
  }

  .side {
    position: sticky;
    top: calc(var(--bar-height) + 20px);
    order: 0;
  }
}
